import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import WorkIndexPage from './pages/WorkIndexPage';
import WorkDetailPage from './pages/WorkDetailPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <>
      <div id="siteHeader">
        <Header />
      </div>

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/work" element={<WorkIndexPage />} />
        <Route path="/work/:id" element={<WorkDetailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <div id="siteFooter">
        <Footer />
      </div>
    </>
  );
}
